import { EMPTY_OBJECT } from '../../../constants/common'
import { getEntityProfileTabTotalCount } from '../../Entity'

import { USER_PROFILE_TABS_COUNTER_SECTION_BY_TAB_ID } from './UserProfileTabs.constants'

function getCanViewUserProfileTab({ permissionKey, permissions }) {
  // The attributes tab has no backend permission key — a keyless tab is not gated.
  if (!permissionKey) {
    return true
  }

  return Boolean(permissions[permissionKey])
}

export function getUserProfileTabSectionCounters(counters, tabId) {
  return counters[USER_PROFILE_TABS_COUNTER_SECTION_BY_TAB_ID[tabId]]
}

export function getUserProfileTabs({
  counters,
  isCountersLoading = false,
  t,
  tabs,
  userData,
}) {
  const permissions = userData?.permissions || EMPTY_OBJECT

  return tabs.reduce(
    (
      acc,
      {
        getCount = getEntityProfileTabTotalCount,
        getHasData = null,
        id,
        permissionKey,
        titleKey,
      }
    ) => {
      if (
        !getCanViewUserProfileTab({ permissionKey, permissions }) ||
        (getHasData && !getHasData(userData))
      ) {
        return acc
      }

      acc.push({
        count: getCount(getUserProfileTabSectionCounters(counters, id)),
        id,
        isCountLoading:
          isCountersLoading &&
          Boolean(USER_PROFILE_TABS_COUNTER_SECTION_BY_TAB_ID[id]),
        text: t(titleKey),
      })

      return acc
    },
    []
  )
}

export function getHasUserProfileTabCounters({ tabs, userData }) {
  return (
    Object.keys(getUserProfileTabCountersParams({ tabs, userData })).length > 0
  )
}

export function getUserProfileTabCountersParams({
  tabIds = null,
  tabs,
  userData,
}) {
  const permissions = userData?.permissions || EMPTY_OBJECT

  return tabs.reduce((acc, { id, permissionKey }) => {
    const counterSection = USER_PROFILE_TABS_COUNTER_SECTION_BY_TAB_ID[id]

    if (
      (!tabIds || tabIds.includes(id)) &&
      counterSection &&
      getCanViewUserProfileTab({ permissionKey, permissions })
    ) {
      acc[counterSection] = true
    }

    return acc
  }, {})
}
